import { Box } from "@mui/material";
import React from "react";
import ReactApexChart from "react-apexcharts";

const DonutChart = ({
  name,
  labels = [],
  series = [],
  disabledSeries = true,
}) => {
  const options = {
    chart: {
      type: "donut",
    },
    plotOptions: {
      pie: {
        startAngle: -90,
        endAngle: 270,
      },
    },
    labels: labels,
    dataLabels: {
      enabled: false,
    },
    legend: {
      formatter: function (val, opts) {
        return disabledSeries
          ? val
          : val + " " + opts.w.globals.series[opts.seriesIndex];
      },
      show: true,
      position: "bottom",
      horizontalAlign: "bottom",
      fontSize: "15px",
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: "100%",
          },
        },
      },
    ],
  };

  return (
    <div className="flex flex-col gap-2">
      <span varint="h6" className="text-[18px] !font-medium text-gray-500 ">
        {name}
      </span>
      <Box
        sx={{
          "& .apexcharts-legend-text": {
            color: "#333",
            fontWeight: 500,
            fontSize: "12px !important",
            padding: "2px 5px",
            backgroundColor: "#f5f5f5",
            borderRadius: "4px",
            margin: "2px 5px",
            transition: "all 0.3s ease",
            "&:hover": {
              backgroundColor: "#e0e0e0",
              color: "#007bff",
              cursor: "pointer",
            },
          },
          "& .apexcharts-legend-marker": {
            borderRadius: "50%",
            width: "10px",
            height: "10px",
            marginRight: "8px",
          },
        }}
      >
        <ReactApexChart
          options={options}
          series={series}
          type="donut"
          height={380}
        />
      </Box>
    </div>
  );
};

export default DonutChart;
